import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {IntegratedKeycloakloginService} from '../integrated.keycloaklogin.service';
import {Headers, Http, RequestOptions} from '@angular/http';


@Injectable()
export class ProfileServices {
    constructor(private integratedKeycloakloginService: IntegratedKeycloakloginService,
                private http: Http) {
    };

    getKeycloakInstance() {
        return this.integratedKeycloakloginService.getKeycloak();
    }

    getKeycloakUrl() {
        const keycloak = this.integratedKeycloakloginService.getKeycloak();
        return keycloak.authServerUrl;
    }

    /**
     * PROFILE
     * 토큰 발급 (broker)
     * Method : Get
     * API No : 1.01
     * {keycloakUrl}admin/realms/{userProfile.attributes.siteCode}/broker/keycloak-oidc/token
     * 미사용.
     * **/
    getNewTokenFromBroker() {
        const keycloakUrl = this.getKeycloakUrl();
        const url = `${keycloakUrl}/realms/${global['loginUser'].siteCd}/broker/keycloak-oidc/token`;
        return this.http
        .get(url)
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    /**
     * PROFILE
     * 토큰 발급
     * Method : Post
     * API No : 1.01
     * {keycloakUrl}admin/realms/{userProfile.attributes.siteCode}/users/{userProfile.id}
     *
     * **/
    getNewToken() {
        const keycloakUrl = this.getKeycloakUrl();
        const keycloakInstance = this.getKeycloakInstance();

        const options = new RequestOptions({withCredentials: true });
        options.headers = new Headers();
        options.headers.append('Content-Type', 'application/x-www-form-urlencoded');
        const body = `client_id=${keycloakInstance.clientId}&grant_type=refresh_token&refresh_token=${keycloakInstance.refreshToken}`;
        const url = `${keycloakUrl}/realms/${global['loginUser'].siteCd}/protocol/openid-connect/token`;
        return this.http
        .post(url, body, options)
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    /**
     * PROFILE
     * 사용자 정보 조회
     * Method : Get
     * API No : 1.01
     * {keycloakUrl}admin/realms/{userProfile.attributes.siteCode}/users/{userProfile.id}
     *
     * **/
    getUserInfo(userProfile) {
        const keycloakUrl = this.getKeycloakUrl();
        const url = `${keycloakUrl}/admin/realms/${userProfile.attributes.siteCode}/users/${userProfile.id}`;
        return this.http
        .get(url)
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    /**
     * PROFILE
     * 사용자 정보 수정
     * Method : Put
     * API No : 1.01
     * {keycloakUrl}admin/realms/{userProfile.attributes.siteCode}/users/{userProfile.id}
     *
     * **/
    updateUserInfo(userProfile) {
        const keycloakUrl = this.getKeycloakUrl();
        const url = `${keycloakUrl}/admin/realms/${userProfile.attributes.siteCode}/users/${userProfile.id}`;
        delete userProfile.userProfileMetadata;
        return this.http
        .put(url, JSON.stringify(userProfile))
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    /**
     * PROFILE
     * 비밀번호 변경
     * Method : Put
     * API No : 1.01
     * {keycloakUrl}admin/realms/{passwordInfo.siteCode}/users/{passwordInfo.id}/reset-password
     *
     * **/
    changePassword(passwordInfo) {
        const keycloakUrl = this.getKeycloakUrl();
        const url = `${keycloakUrl}/admin/realms/${passwordInfo.siteCode}/users/${passwordInfo.id}/reset-password`;
        delete passwordInfo.siteCode;
        return this.http
        .put(url, JSON.stringify(passwordInfo))
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    /**
     * PROFILE
     * 회원 탈퇴
     * Method : Delete
     * API No : 1.01
     * {keycloakUrl}admin/realms/{userProfile.attributes.siteCode}/users/{userProfile.id}
     *
     * **/
    resignMembership(userProfile) {
        const keycloakUrl = this.getKeycloakUrl();
        const url = `${keycloakUrl}/admin/realms/${userProfile.attributes.siteCode}/users/${userProfile.id}`;
        delete userProfile.userProfileMetadata;
        return this.http
        .delete(url, JSON.stringify(userProfile))
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    private handleError(error: any) {
        return Promise.resolve(error.message || error);
    }
}






// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/profile.services.ts